import React from "react";
import { Loader } from "lucide-react";

interface ReviewResultsStatusProps {
  loading: boolean;
  hasItems: boolean;
  hasTerms: boolean;
  failed?: boolean;
}

export const ReviewResultsStatus: React.FC<ReviewResultsStatusProps> = ({
  loading,
  hasItems,
  hasTerms,
  failed = false,
}) => {
  if (!hasTerms) return null;
  if (failed && !hasItems) {
    return (
      <p className="text-sm text-danger-200 text-center py-8">
        Couldn&apos;t load your review results. Please try again.
      </p>
    );
  }
  if (loading && !hasItems) {
    return (
      <div className="flex justify-center items-center py-8 gap-2 text-sm text-neutral-500">
        <Loader className="animate-spin" />
        Loading review results...
      </div>
    );
  }
  if (!loading && !hasItems) {
    return (
      <p className="text-sm text-neutral-500 text-center py-8">
        No review findings for this option. If you just ran Analyse, wait a moment and open Review
        again, or run Analyse once more.
      </p>
    );
  }
  return null;
};
